import { GetPageByRouteQuery } from "apollo"
import { BlockRenderer } from "ui"
import { getBreadCrumbs, TrafficUpdate, transformProperties } from "utils"
import TrafficUpdates from "./TrafficUpdates"

type Props = {
  data: GetPageByRouteQuery
  locale: string
  trafficUpdates: TrafficUpdate[]
}

const components = {
  heroBanner: () => import("../Common/Hero"),
  adynamicTitleAndContant: () => import("../Common/DynamicTitle"),
}

export default function TrafficLobby({ data, locale, trafficUpdates }: Props) {
  const parsedData = data?.page?.properties || []
  const { blocks } = transformProperties(parsedData)
  const breadCrumbs = getBreadCrumbs(data, locale)

  return (
    <>
      {blocks?.blocks?.map(
        // TO DO : HOW TO FIND BLOCK TYPE IN GENERATED GRAPHQL TYPES
        (block: any, index: number) => {
          return (
            <BlockRenderer
              key={index}
              blockType={block.blockType}
              blockData={block}
              components={components}
              locale={locale}
              props={{ breadCrumbs }}
            />
          )
        },
      )}
      <TrafficUpdates trafficUpdates={trafficUpdates} />
    </>
  )
}
